/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Page Settings Styled
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';

export const PageSettingsWrapperStyled = styled.div`
    position: relative;
    border-top: 1px solid ${colors.borderColorLight};
`;

export const PageSettingsContentStyled = styled.div`
    padding: 24px 24px 48px;
    padding-right: 0;
`;

export const PageSettingsHeaderStyled = styled.h4`
    ${fonts.textMainBold};
    margin: 0;
    margin-bottom: 24px;
`;

export const PageSettingsHeaderContainerStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    & ${PageSettingsHeaderStyled} {
        margin-bottom: 0;
    }
`;

export const PageSettingsCounterStyled = styled.span`
    display: inline-block;
    min-width: 24px;
    height: 24px;
    margin-left: 4px;
    padding: 0 8px;
    box-sizing: border-box;
    border-radius: 12px;
    background-color: ${colors.backgroundColorModal};
    text-align: center;
    ${fonts.textSmall};
    line-height: 24px;
`;

export const PageTitleElementsContainerStyled = styled.div`
    display: flex;
    align-items: center;
`;
